import { render, staticRenderFns } from "./ContentServiceList.vue?vue&type=template&id=15280c9c&"
import script from "./ContentServiceList.vue?vue&type=script&lang=js&"
export * from "./ContentServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports